import ApplicationSerializer from 'eflex/serializers/application';

export default class TaskSerializer extends ApplicationSerializer {
  attrs = {
    taskConfigs: {
      deserialize: false,
      serialize: false,
    },
    cameraConfiguration: {
      embedded: 'always',
    },
    edhrMappings: {
      embedded: 'always',
    },
    hardwareInputDefs: {
      embedded: 'always',
    },
    variableDefs: {
      embedded: 'always',
    },
    jemPartMarriages: {
      embedded: 'always',
    },
    triggers: {
      embedded: 'always',
    },
    decisionDefs: {
      embedded: 'always',
    },
    spindles: {
      embedded: 'always',
    },
    strings: {
      embedded: 'always',
    },
    materials: {
      serialize: 'ids',
      deserialize: 'ids',
    },
  };
}
